import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from '../services/user.service';
import { RouterService } from 'src/app/core/services/router/router.service';

@Injectable()
export class BackOfficeGuard implements CanActivate {
    constructor(
        private router: Router,
        private userService: UserService,
        private routerService: RouterService
    ) { }

    canActivate(): boolean {
        let flag = false;

        this.userService.getUser().user.roles.forEach(rol => {
            if (rol.role == 'ADMIN') {
                flag = true;
            }
            if (rol.role == 'LUNCH' && this.routerService.getActivationStartUrl() == '/intranet/backOffice/pedidos') {
                flag = true;
            }
        });

        if (!flag) {
            this.router.navigate(['intranet/novedades/home']);
        }
        return flag;
    }
}